import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import "us.style/antd.less";
import "us.style/index.scss";
import { Loader } from "us.common/components/Loader";

import App from "App";
import * as serviceWorker from "serviceWorker";
import store, { history } from "store";
import * as Azure from "us.helper/azure";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { setupTitle } from "us.helper";
import { MsalProvider } from "@azure/msal-react";
import "us.helper/utility/dayjsConfig";

// Set global identifier
window.APP_MODULE = "reports";

// Initialize MSAL
export const msalInstance = new PublicClientApplication(Azure.msalConfig);

// Handle initial account state
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

// Enable account storage event (cross-tab sync)
msalInstance.enableAccountStorageEvents();

// MSAL Event Callbacks
msalInstance.addEventCallback((event: EventMessage) => {
  if (
    [EventType.LOGIN_SUCCESS, EventType.SSO_SILENT_SUCCESS].includes(
      event.eventType
    ) &&
    event.payload
  ) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
    msalInstance.setActiveAccount(null);
    window.location.reload();
  }
});

// Setup dynamic page title
setupTitle();

// React App Mount
const app = (
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <Suspense fallback={<Loader />}>
        <App history={history} msalInstance={msalInstance} />
      </Suspense>
    </MsalProvider>
  </Provider>
);

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(app);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
